<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgement">
<h1>Acknowledgement</h1>
<p style="text-indent:0em !important;">To my readers,</p><br/>
<p style="text-indent:0em !important;">Thank you for your infinite support before, during, and after the release of the first book in the Colour Coded series.</p><br/>
<p style="text-indent:0em !important;">Because of that, the publishing of this book was possible. Because of that, you have made my dreams come true.</p><br/>
<p style="text-indent:0em !important;">That alone, is a debt I can only repay by continuing to invite you to join me in the adventures of Colour Coded and by remaining hopeful that I continue to serve you well.</p><br/>
<p style="text-indent:0em !important;">Thank you.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch004.vue?f90a6a62